import { Component, h } from 'preact';

import getStore from '../../../store';
import * as InquiriesActions from '../../../reducers/inquiries/inquiries.actions';

import { Inquiry } from '../../../../../types/inquiries';
import { InqOfferAcceptedModal } from './inq-offer-accepted-modal.component';
import { ReqState } from '../../../../../types';
import { InquiryDocument } from 'inquiries/inquiry-document.model';
import { inquiryService } from '../../../../utils/inquiry.service';

interface InqOfferAcceptedModalHostProps {
  onClose: () => void;
  inquiry: Inquiry
}

interface InqOfferAcceptedModalHostState {
  offerReqState?: ReqState;
  submitState?: ReqState;
  documentChoices?: InquiryDocument[];
}

const store = getStore();

export class InqOfferAcceptedModalHost extends Component<InqOfferAcceptedModalHostProps, InqOfferAcceptedModalHostState> {
  async componentDidMount() {
    const inquiry = this.props.inquiry;
    try {
      this.setState({ offerReqState: ReqState.IN_PROGRESS });
      const docs = await inquiryService.getOfferList(inquiry.inquiryCode);
      this.setState({ documentChoices: docs.results, offerReqState: ReqState.SUCCESS });
    } catch (err) {
      console.error(err);
      this.setState({ offerReqState: ReqState.FAILED });
    }
  }

  async onSubmit(loiKey: string, date: string, files: FileList) {
    const inquiryCode = this.props.inquiry.inquiryCode
    try {
      this.setState({ submitState: ReqState.IN_PROGRESS });
      const acceptRes = await inquiryService.markOfferAsAccepted(inquiryCode, loiKey, date);

      if (files && files.length > 0) {
        const uploadRes = await inquiryService.uploadOfferImageFiles(inquiryCode, loiKey, files);
      }

      this.setState({ submitState: ReqState.SUCCESS });

      store.dispatch(InquiriesActions.attachmentUpdatedForInquiry(this.props.inquiry));
      store.dispatch(InquiriesActions.loadAllStages());
    } catch (err) {
      console.log(err);
      this.setState({ submitState: ReqState.FAILED });
    }
  }

  render(props: InqOfferAcceptedModalHostProps, state: InqOfferAcceptedModalHostState) {
    return (
      <InqOfferAcceptedModal offerReqState={ state.offerReqState }
        submitState={ state.submitState }
        documentChoices={ state.documentChoices }
        onClose={ props.onClose }
        onSubmit={ (loiKey, date, files) => this.onSubmit(loiKey, date, files) } />
    );
  }
}
